export default function() {
  return !this.node();
}



//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/d3-selection/src/selection/empty.js
// module id = ../../../../d3-selection/src/selection/empty.js
// module chunks = 3